import { createSelector } from '@ngrx/store'

export const getMobileTasksState = createSelector(
  (state: any) => state.mobileTasks,
  (state: any) => state.get('list'),
)

export const getAutoAssignTasksState = createSelector(
  (state: any) => state.mobileTasks,
  (state: any) => state.get('autoAssignTasks'),
)
